(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .directive('accountForm', accountForm);

  function accountForm() {
    return {
      restrict: 'E',
      scope: {
        errorMessage: '&',
        fi: '=',
        form: '=',
        hasError: '&',
        saveFi: '&',
        states: '='
      },
      templateUrl: '/templates/compliance_framework/components/account-form.directive.html'
    };
  }
})();
